import removeItemRefSaleOrder from './removeItemRefSaleOrder';
import removeItemRefPurchaseOrder from './removeItemRefPurchaseOrder';

export default [removeItemRefSaleOrder, removeItemRefPurchaseOrder];
